import { array_has_intersection, debounce } from "../inc/helpers";
import Pqp from "../inc/Pqp";

export default class PageHome {
  constructor() {
    this.data = null;
    this.label_scroll = null;
  }

  init(data) {
    this.data = data;

    this.init_swiper_services();
    this.init_sections_scroll();
    this.init_cati_club_scroll();
  }

  init_swiper_services() {
    const services_block = document.querySelectorAll(".js-swiper-services");
    
    services_block?.forEach(s => {
      if (s.querySelectorAll(".swiper-slide")?.length <= 1) 
        return;
      
      const navigation = s.parentNode?.querySelector(".js-swiper-navigation");
      const btn_next = navigation?.querySelector(".swiper-button-next");
      const btn_prev = navigation?.querySelector(".swiper-button-prev");
      const swiper = new Swiper(s, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: btn_next,
          prevEl: btn_prev
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 2.5
          },
          992: {
            slidesPerView: 3.5,
            slidesPerGroup: 3.5
          }
        }
      });
      navigation.classList.remove("is-hidden");
    });
  }

  init_sections_scroll() {
    const opts = {
      root: null,
      rootMargin: "0px",
      threshold: .5 // when 50% of elem is visible it triggers the callback
    };
    const entries = [
      document.querySelector(".js-cards"),
      document.querySelector(".js-numbers")
    ];    
    const callback = (entries) => {      
      entries.forEach(entry => {
        if (window.scrollY > entry.boundingClientRect.top) {
          !entry.target.classList.contains("is-visible")
            && entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        
        } else if (entry.isIntersecting) {
          !entry.target.classList.contains("is-visible")
            && entry.target.classList.add("is-visible");
        }
      });
    };
    const observer = new IntersectionObserver(callback, opts);
    
    entries.forEach(entry => entry && observer.observe(entry));
  }

  init_cati_club_scroll() {
    const sections = this.config_label();
    
    if (!Array.isArray(sections) || Pqp.isNullOrEmpty(this.label_scroll)) return;
    
    let y, sections_h, nav_h, start, distance, distance_offset, vh;
    const setup_vars = () => {
      y = 0;
      sections_h = sections.reduce((sum, el) => sum + el.offsetHeight, 0);
      nav_h = parseInt(document.body.style.getPropertyValue("--nav-h"));
      start = sections[0].offsetTop - nav_h;
      distance = sections_h - this.label_scroll.offsetHeight;
      distance_offset = distance;
      vh = window.innerHeight > window.innerWidth ?  window.innerHeight / 2 : window.innerHeight;
      
      this.label_scroll.style.setProperty("bottom", `${distance}px`);

      // place the label where it should be on page load and resize
      if (window.scrollY > start) {
        const delta = Math.floor(window.scrollY - start);
        const gamma = Math.floor(delta * distance / (sections_h - vh));
        
        distance_offset = 
          distance_offset - gamma > 0 
            ? distance_offset - gamma
            : 0;
        
        this.label_scroll.style.setProperty("bottom", `${distance_offset}px`);
        y = window.scrollY;
      }
    }
    setup_vars();    
    const reset_scroll = debounce(() => setup_vars(), 750);
    const handle_scroll = () => {
      const delta = Math.floor(window.scrollY - y);
      
      // scroll down
      if (window.scrollY > y && window.scrollY > start) {        
        const gamma = Math.floor(delta * distance / (sections_h - vh));
        
        if (distance_offset > 0) {
          distance_offset -= gamma;
        
        } else {
          distance_offset = 0;
        }        
      
      // scroll up
      } else {
        const gamma = Math.floor(delta * distance / sections_h);
        
        if (distance_offset < distance) {
          distance_offset += gamma * -1;
        
        } else {
          distance_offset = distance;
        }
      }      

      this.label_scroll.style.setProperty("bottom", `${distance_offset}px`);
      y = window.scrollY;
    }    

    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", reset_scroll);
  }

  config_label() {
    const section_classes = ["js-solutions", "js-services", "js-cards-bg"];
    const sections = Array.from(document.querySelectorAll(".content-section"));
    const section_first = sections?.find(s => array_has_intersection(Array.from(s.classList), section_classes));
    let nth_0, nth_1, nth_2;    
    
    if (Pqp.isNullOrEmpty(section_first)) return;
    
    nth_0 = section_first;
    nth_1 = nth_0.nextElementSibling;
    nth_2 = nth_1.nextElementSibling;
    
    if (Pqp.isNullOrEmpty(nth_1) || Pqp.isNullOrEmpty(nth_2)) return;

    const int_1 = array_has_intersection(Array.from(nth_1.classList), section_classes);
    const int_2 = array_has_intersection(Array.from(nth_2.classList), section_classes);
    
    if (!int_1 || !int_2) return;

    this.label_scroll = document.querySelector("#template-label-scroll")?.cloneNode();
    document.querySelector("main").appendChild(this.label_scroll);    

    return [nth_0, nth_1, nth_2];
  }
}